import React from 'react';
import { X } from "lucide-react";

const ConfirmModal = ({ isOpen, title, message, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black bg-opacity-70 sm:px-6">
      <div className="relative w-full max-w-md overflow-hidden bg-gray-900 border border-gray-800 rounded-lg shadow-lg">
        {/* Botón cerrar */}
        <button
          onClick={onCancel}
          className="absolute z-10 p-1.5 bg-gray-800 rounded-full top-3 right-3 hover:bg-gray-700"
        >
          <X className="w-5 h-5 text-gray-300" />
        </button>

        {/* Contenido del modal */}
        <div className="p-6">
          <h3 className="mb-4 text-xl font-bold text-white">{title}</h3>
          
          <div className="mb-6 text-gray-300 whitespace-pre-line">
            {message}
          </div>
          
          <div className="flex justify-end space-x-3">
            <button
              onClick={onCancel}
              className="px-5 py-2 text-sm font-medium text-white bg-gray-700 rounded-md hover:bg-gray-600 transition-colors"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              className="px-5 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
            >
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
